/**
 * The one-line promise the site makes above every grid: the puzzles are verified,
 * so a careful player never has to guess.
 *
 * One constant serves the two places a page's header exists — the build-time static
 * document and the React app — so the claim cannot drift between what a crawler
 * reads and what a player sees. The element is small on purpose: it is a promise,
 * not a banner, and the grid stays the hero of the page.
 */

export const TRUST_BADGE_TEXT =
  "Every puzzle verified — one solution, pure logic, no guessing";

const TRUST_BADGE_CHECK_SVG =
  '<svg class="trust-badge-check" aria-hidden="true" viewBox="0 0 16 16" width="14" height="14" focusable="false">' +
  '<circle cx="8" cy="8" r="7.15" fill="none" stroke="currentColor" stroke-width="1.3"></circle>' +
  '<path d="M4.9 8.2 7 10.3l4.1-4.6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>' +
  "</svg>";

/** The badge's inner markup, so React can build the identical element itself. */
export const TRUST_BADGE_INNER_HTML = `${TRUST_BADGE_CHECK_SVG}${TRUST_BADGE_TEXT}`;

/** The badge as a complete element, for the static document and dated archive pages. */
export function trustBadgeHtml(): string {
  return `<p class="trust-badge">${TRUST_BADGE_INNER_HTML}</p>`;
}
